"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessController = void 0;
const urn_parser_1 = require("./urn-parser");
class AccessController {
    constructor(userScopes) {
        if (userScopes) {
            this.accessMap = urn_parser_1.parseURN(userScopes);
        }
    }
    // 1. Überprüfe, ob scopes angefragt wurden
    // 2. Überprüfe, ob jedes Modul verfügbar ist
    // 3. Überprüfe, ob alle Rechte innerhalb jedes Moduls verfügbar sind
    can(requestedScopes) {
        var _a;
        if (!(requestedScopes === null || requestedScopes === void 0 ? void 0 : requestedScopes.length) || !((_a = this.accessMap) === null || _a === void 0 ? void 0 : _a.size)) {
            return false;
        }
        try {
            const parsedRequest = urn_parser_1.parseURN(requestedScopes);
            for (const module of parsedRequest.keys()) {
                // 2. Überprüfe, ob jedes Modul verfügbar ist
                if (!this.accessMap.has(module)) {
                    return false;
                }
                // 3. Überprüfe, ob alle Rechte innerhalb jedes Moduls verfügbar sind
                const requestedRights = parsedRequest.get(module);
                if (!Object.keys(requestedRights).every((right) => this.accessMap.get(module)[right])) {
                    return false;
                }
            }
        }
        catch (error) {
            if (error instanceof urn_parser_1.ParsingError) {
                return false;
            }
            throw error;
        }
        return true;
    }
    updateUserScopes(userScopes) {
        this.accessMap = urn_parser_1.parseURN(userScopes);
    }
}
exports.AccessController = AccessController;
